(function($){
    $(window).on("load",function(){
        $(".section__slider").mCustomScrollbar({
            axis:"x",
            mouseWheel:{ enable: false },
            advanced:{autoExpandHorizontalScroll:true}, //auto-expand content to accommodate floated elements
            // change mouse-wheel axis on-the-fly 
      });
    });
})(jQuery);

$('.section-service__slider').slick({
    dots: false,
    arrows: false,
    variableWidth: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    responsive: [{
      breakpoint: 1020,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 840,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 560,
      settings: {
        slidesToShow: 1
      }
    }]
})

$('.section-service__arrow').click(function () {
    var type = $(this).data('type')

    if (type === 'prev') {
        $('.section-service__slider').slick('slickPrev');
    } else {
        $('.section-service__slider').slick('slickNext');
    }
})
